import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./../authConfig";

var instance = new PublicClientApplication(msalConfig);
class MsalInstance {
    static getCurrentInstance = () => {
        if (!instance) {
            instance = new PublicClientApplication(msalConfig);
        }

        return instance;
    }
}

export {instance, MsalInstance};